export const stopVideosPlaying = () => {
    const videos = document.querySelectorAll('video')
    videos && videos.forEach((video) => {
        const videoSrc = video.getAttribute('src')
        videoSrc && video.setAttribute('src', videoSrc)
    })
}

type UUID = `${string}-${string}-${string}-${string}-${string}`

const makeCustomFieldsAvailableToPlugin = (remoteDataset: any, dataset_defaults: any)=> {
    let customFields = {}
    // if the fetched config has keys that aren't in dataset defaults, add them to customFields
    for (const [key, value] of Object.entries(remoteDataset)) {
        if (!dataset_defaults[key]) {
            customFields = {...customFields, [key]: value}
        }
    }
    // loop new customFields object and save each to sessionStorage for use in given plugin
    for (const [key, value] of Object.entries(customFields)) {
        if (value !== undefined && value !== null) {
            sessionStorage.setItem(key.toString(), String(value))
        }
    }
}

export const fetchConfig = async (currentConfig: any, dataset_defaults: any) => {
    interface RemoteConfig {
        id?: UUID
        config: boolean | [{ [key: string]: unknown }]
        name?: string
        domain?: string
        active?: boolean
        custom_rasa_server_endpoint?: string
        custom_rasa_server_token?: string
        organisation_name?: string
        sponsor_enabled?: boolean
        further_info_link?: string
        further_info_link_text: string
        further_info_text: string
    }
    let newConfig = currentConfig
    if (currentConfig.remote_config_url) {
        let fetched: RemoteConfig
        const response = await fetch(currentConfig.remote_config_url, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        }).catch(e => {
            // this error handling could be improved. Currently the widget blank screens when
            // the url has a typo/the server is down etc. error should distinguish this.
            console.error(e)
        })
        fetched = await response?.json()
        if (fetched?.config) {
            let newTenantConfig = fetched?.config
            for (const [key, value] of Object.entries(newTenantConfig)) {
                if (value) {
                    newConfig = {...newConfig, [key]: value}
                }
            }
            makeCustomFieldsAvailableToPlugin(newTenantConfig, dataset_defaults)
        }
        newConfig.tenant_id = fetched?.id
        newConfig.organisation_name = fetched?.organisation_name
        newConfig.sponsor_enabled = fetched?.sponsor_enabled
        newConfig.further_info_link = fetched?.further_info_link
        newConfig.further_info_link_text = fetched?.further_info_link_text
        newConfig.further_info_text = fetched?.further_info_text
    }
    return newConfig
}
